import React from 'react'
import Div from '@jarvis.oddle/core/components/Div'
import { useFormContext } from '@jarvis.oddle/core/components/Form'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'

interface NotificationProps {
  showAgreement?: boolean
}

const Notification = ({
  showAgreement = false
}: NotificationProps): JSX.Element => {
  const { errors } = useFormContext()
  return (
    <React.Fragment>
      {showAgreement && errors.termsError && (
        <Div marginBottom={marginSizes.small} marginTop={marginSizes.small}>
          <InlineNotification
            lightTheme
            state={notificationStates.error}
            text={errors.termsError}
          />
        </Div>
      )}
      {errors.serverError && (
        <Div marginBottom={marginSizes.small}>
          {(errors.serverError || []).map(
            (error, idx) =>
              error && (
                <Div key={idx} marginTop={marginSizes.small}>
                  <InlineNotification
                    lightTheme
                    state={notificationStates.error}
                    text={error}
                  />
                </Div>
              )
          )}
        </Div>
      )}
    </React.Fragment>
  )
}

export default Notification
